import React from 'react'
import { IoChevronBack } from 'react-icons/io5'
import { FiShare2 } from 'react-icons/fi'
import { CompError, DetailsPedido, DetalhesQuadra } from '../../Complex'
import { CardHeader, Box, Typography, IconButton, Button } from '@mui/material'
import { Alerts, InputButton, Loading } from '../../Simple'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { LocalStorage, Services } from '../../../services'
import RouterHook from '../../../contexts/RouterHook'
import { MdPix } from 'react-icons/md'
import moment from 'moment'
import { CancelarPedido, HistoricoAgendamento } from '../../Modais'
import { ChatContext } from '../../../contexts/ChatContext'
import * as htmlToImage from 'html-to-image'
import useDetalhesAgendamento from './DetalhesAgendamento.functions'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'
import { ToastMessages } from '../../ToastMessages.jsx'

export default function MobileAgendamento() {
  const serverRouter = RouterHook()
  const { sttCtxAgend, loadAgend, actionsAgend, modaisAgend } = React.useContext(AgendamentoContext)
  const {
    verificarAcessoUsuario,
    buscarPedido,
    isLimiteReagendamentoExcedido,
    checarRegraCancelamento,
    semAcesso,
  } = useDetalhesAgendamento()

  const { actionsCtxEmps, BuscarQuadrasEmpresa } = React.useContext(EmpresasContext)
  const { sttChatCtx, actionsChatCtx } = React.useContext(ChatContext)
  const shareRef = React.useRef(null)

  const pagamentoLocal =
    sttCtxAgend.pedido.formaPagamento === 'DINHEIRO' ||
    sttCtxAgend.pedido.formaPagamento === 'LOCAL' ||
    sttCtxAgend.pedido.formaPagamento === 'MAQUINA_CARTAO'

  const reagendavel =
    (sttCtxAgend.pedido.status === 'AGENDADO' || sttCtxAgend.pedido.status === 'SOLICITADO') &&
    !(sttCtxAgend.pedido.status === 'SOLICITADO' && sttCtxAgend.pedido.formaPagamento === 'PIX')

  React.useEffect(() => {
    const url = window.location.href
    const idpedido = url.split('/').pop()
    buscarPedido(idpedido).then(pedido => {
      verificarAcessoUsuario(pedido)
    })
  }, [])

  React.useEffect(() => {
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', handleSttPage)
    return () => {
      window.removeEventListener('popstate', handleSttPage)
    }
  }, [modaisAgend.cancelamento])

  //console.log('sttCtxAgend :: ', sttCtxAgend)
  async function handleShare() {
    try {
      const dataUrl = await htmlToImage.toPng(shareRef.current)

      const shareData = {
        title: 'Jogo Agendado!👏😄',
        text: '📲 Baixe também o App Agendei Quadras: bit.ly/AgendeiQuadrasApp',
        files: [
          new File([await (await fetch(dataUrl)).blob()], 'agendamento.png', { type: 'image/png' }),
        ],
      }

      if (navigator.share) {
        await navigator.share(shareData)
      }
    } catch (error) {
      console.error('Error sharing:', error)
    }
  }

  function handleReagendar() {
    if (isLimiteReagendamentoExcedido()) ToastMessages.userRescheduleLimit()
    else if (!checarRegraCancelamento()) ToastMessages.rescheduleTimeExpired()
    else
      Alerts.question(
        'Deseja reagendar este horário?',
        sttCtxAgend.pedido.status === 'AGENDADO' &&
          pagamentoLocal &&
          !sttCtxAgend.pedido.mensalista_idmensalista
          ? 'O novo horário precisará ser aprovado pelo gestor da quadra.'
          : 'Você conseguirá reagendar até 2 vezes, dentro de no máximo 30 dias.',
        () => {
          Reagendar()
        },
      )
  }

  async function Reagendar() {
    actionsAgend.ReagendarAgendamento()
    const { quadras } = await BuscarQuadrasEmpresa(sttCtxAgend.pedido.empresa.idempresa)
    const selectedQuadra = quadras.find(
      quadra => quadra.idquadra === sttCtxAgend.pedido.quadra.idquadra,
    )
    LocalStorage.set('selected-quadra', selectedQuadra)
    actionsCtxEmps.handleModeSttPg({
      modePg: 'grade',
      selectedQuadra: selectedQuadra,
      selectedHorarios: [],
    }),
      actionsCtxEmps.handleSttPg('selectedDay', moment(sttCtxAgend.pedido.dataInicio))
    serverRouter('centro-esportivo', sttCtxAgend.pedido.empresa.username)
  }

  function GoChatPedido() {
    if (sttChatCtx.modeChat !== 'agendamentos') actionsChatCtx.handleModeChat('agendamentos')
    actionsChatCtx.AbrirChatPedido(sttCtxAgend.pedido.chat_idchat)
    serverRouter('chat', sttCtxAgend.pedido.usuario_idusuario)
  }

  function StartGoPix() {
    //console.log('start go pix', sttCtxAgend)
    serverRouter('pay-pix', sttCtxAgend.pedido.idpagamento)
  }

  function handleSttPage() {
    if (modaisAgend.cancelamento) actionsAgend.handleModaisAgend('cancelamento', false)
    else serverRouter('back')
  }

  function AbrirModalHistorico() {
    actionsAgend.handleModaisAgend('historicoAgendamento', true)
  }

  return (
    <div className='contain-page-detalhes-pedido'>
      {modaisAgend.cancelamento && <CancelarPedido />}
      {modaisAgend.historicoAgendamento && <HistoricoAgendamento pedido={sttCtxAgend.pedido} />}
      {loadAgend.page ? (
        <Box className='contain-loading'>
          <Loading text={'Carregando Agendamento...'} />
        </Box>
      ) : semAcesso ? (
        <CompError
          title={'Agendamento não encontrado'}
          message={'O agendamento que você está tentando acessar não foi encontrado.'}
        />
      ) : (
        <>
          <CardHeader
            sx={{
              padding: '5px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              margin: '0',
              width: '100%',
              '& .MuiCardHeader-avatar': {
                padding: '0px !important',
                margin: '0px !important',
              },
            }}
            avatar={<IoChevronBack onClick={() => serverRouter('back')} style={stMob.iconBack} />}
            title={
              <Box className='contain-header-titles'>
                <Typography className='text-title-page'>Agendamento</Typography>
                <Typography>Nº #{window.location.href.split('/').pop()}</Typography>
              </Box>
            }
            action={
              <IconButton size={'large'} onClick={handleShare} sx={{ color: 'primary.main', p: 2 }}>
                <FiShare2 />
              </IconButton>
            }
          />
          <Box className='contain-internal-page'>
            <Button
              fullWidth
              variant='text'
              onClick={AbrirModalHistorico}
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Typography variant='body2'>Histórico do agendamento</Typography>
              <ChevronRightRoundedIcon />
            </Button>

            <div className='tw-w-full' ref={shareRef}>
              <DetailsPedido />
              <DetalhesQuadra pedido={sttCtxAgend.pedido} />
            </div>
            <Box className='contain-detalhes-pagamento'>
              <Typography variant='h6' sx={stMob.titleComponent}>
                Pagamento
              </Typography>
              <Box sx={stMob.containGrid}>
                <Box sx={stMob.containItem}>
                  <Typography sx={stMob.titleGrid}>Forma de pagamento</Typography>
                  <Typography sx={stMob.labelGrid}>
                    {Services.ReturnMetodoPay(sttCtxAgend.pedido.formaPagamento)}
                  </Typography>
                </Box>
                <Box sx={stMob.containItem}>
                  <Typography sx={stMob.titleGrid}>Subtotal</Typography>
                  <Typography sx={stMob.labelGrid}>
                    {Services.FormatValor(sttCtxAgend.pedido.valorTotal)}
                  </Typography>
                </Box>
                {sttCtxAgend.pedido.valorDesconto > 0 && (
                  <Box sx={stMob.containItem}>
                    <Typography sx={stMob.titleGrid}>Desconto</Typography>
                    <Typography sx={stMob.labelGrid}>
                      {Services.FormatValor(sttCtxAgend.pedido.valorDesconto)}
                    </Typography>
                  </Box>
                )}
                {sttCtxAgend.pedido.valorDesconto > 0 && (
                  <Box sx={stMob.containItem}>
                    <Typography sx={stMob.titleGrid}>Valor total com desconto</Typography>
                    <Typography sx={stMob.labelGrid}>
                      {Services.FormatValor(
                        sttCtxAgend.pedido.valorTotal - sttCtxAgend.pedido.valorDesconto,
                      )}
                    </Typography>
                  </Box>
                )}
                {sttCtxAgend.pedido.valorPendente > 0 &&
                  sttCtxAgend.pedido.status !== 'CANCELADO' && (
                    <Box sx={stMob.containItem}>
                      <Typography sx={stMob.titleGrid}>Pendente</Typography>
                      <Typography sx={{ ...stMob.labelGrid, color: '#edb201' }}>
                        {Services.FormatValor(sttCtxAgend.pedido.valorPendente)}
                      </Typography>
                    </Box>
                  )}
                {sttCtxAgend.pedido.valorRealizado > 0 &&
                  sttCtxAgend.pedido.status !== 'CANCELADO' && (
                    <Box sx={stMob.containItem}>
                      <Typography sx={stMob.titleGrid}>Pago</Typography>
                      <Typography sx={{ ...stMob.labelGrid, color: '#24ad49' }}>
                        {Services.FormatValor(sttCtxAgend.pedido.valorRealizado)}
                      </Typography>
                    </Box>
                  )}
                {sttCtxAgend.pedido.valorEstornado > 0 && (
                  <Box sx={stMob.containItem}>
                    <Typography sx={stMob.titleGrid}>Estornado</Typography>
                    <Typography sx={{ ...stMob.labelGrid, color: '#be3223' }}>
                      {Services.FormatValor(sttCtxAgend.pedido.valorEstornado)}
                    </Typography>
                  </Box>
                )}
                {sttCtxAgend.pedido.valorRealizado > 0 &&
                  sttCtxAgend.pedido.status === 'CANCELADO' && (
                    <Box sx={stMob.containItem}>
                      <Typography sx={stMob.titleGrid}>Multa por cancelamento</Typography>
                      <Typography sx={{ ...stMob.labelGrid, color: '#be3223' }}>
                        {Services.FormatValor(sttCtxAgend.pedido.valorRealizado)}
                      </Typography>
                    </Box>
                  )}
                {(sttCtxAgend.pedido.status === 'SOLICITADO' ||
                  sttCtxAgend.pedido.status === 'AGENDADO') &&
                  (sttCtxAgend.pedido.formaPagamento === 'DINHEIRO' ||
                    sttCtxAgend.pedido.formaPagamento === 'MAQUINA_CARTAO') && (
                    <Box sx={stMob.containItem}>
                      <Typography sx={stMob.titleGrid}>Pague no local</Typography>
                      <Typography sx={stMob.labelGrid}>
                        {Services.FormatValor(sttCtxAgend.pedido.valorAPagar)}
                      </Typography>
                    </Box>
                  )}
                {sttCtxAgend.pedido.status === 'SOLICITADO' &&
                  sttCtxAgend.pedido.formaPagamento === 'PIX' && (
                    <InputButton
                      fullWidth
                      variant='outlined'
                      sx={stMob.buttomPix}
                      onClick={() => {
                        StartGoPix()
                      }}
                      endIcon={<MdPix className='btt-icon-pix' size={30} />}
                    >
                      Ver código PIX
                    </InputButton>
                  )}
              </Box>
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ pb: 2 }}>
              <div
                className='rtz-banner'
                data-rtz-espaco-id='118'
                style={{ width: '320px', height: '100px', overflow: `hidden` }}
                data-rtz-width='320'
                data-rtz-height='100'
                title='Espaço publicitário'
                data-rtz-display-formato='imagem_video'
                data-rtz-tipo-criativo='360'
                data-rtz-device='mobile'
              ></div>
            </Box>
            {(sttCtxAgend.pedido.status === 'SOLICITADO' ||
              sttCtxAgend.pedido.status === 'AGENDADO') && (
              <Box sx={stMob.containFixed}>
                <InputButton
                  fullWidth
                  variant='contained'
                  sx={{ ...stMob.buttomGeneric, backgroundColor: 'secondary.lightBlue' }}
                  onClick={() => {
                    GoChatPedido()
                  }}
                >
                  {/* <IoChatbubblesSharp size={20} /> */}
                  <Typography sx={{ fontWeight: 'bold' }}>Chat</Typography>
                </InputButton>

                {reagendavel && (
                  <InputButton
                    fullWidth
                    variant='contained'
                    color='primary'
                    sx={{ ...stMob.buttomGeneric }}
                    onClick={() => {
                      handleReagendar()
                    }}
                  >
                    <Box sx={stMob.buttonContent}>
                      <Typography sx={{ fontWeight: 'bold' }}>Reagendar</Typography>
                    </Box>
                  </InputButton>
                )}

                {sttCtxAgend.pedido.formaPagamento !== 'PIX' && (
                  <InputButton
                    fullWidth
                    variant='contained'
                    sx={{ ...stMob.buttomGeneric, backgroundColor: '#f25546' }}
                    onClick={() => {
                      actionsAgend.handleModaisAgend('cancelamento', true)
                    }}
                  >
                    <Box sx={stMob.buttonContent}>
                      {/* <IoClose size={20} /> */}
                      <Typography sx={{ fontWeight: 'bold' }}>Cancelar</Typography>
                    </Box>
                  </InputButton>
                )}
              </Box>
            )}
          </Box>
        </>
      )}
    </div>
  )
}

const stMob = {
  containGrid: {
    width: '100%',
    padding: '0px 0px 0px 10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  containItem: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleComponent: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: 'var(--color-text-hig)',
    width: '100%',
    textAlign: 'left',
  },
  iconBack: {
    color: '#ff7043',
    height: '27px',
    width: '27px',
    marginRight: '7px',
  },
  titleGrid: {
    fontSize: '16px',
    color: 'var(--color-text-pri)',
    width: '100%',
    textAlign: 'left',
  },
  labelGrid: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'var(--color-text-pri)',
    width: '100%',
    textAlign: 'right',
  },
  containFixed: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 5px 0px 5px',
    fontSize: '16px',
    borderRadius: '0px',
  },
  buttomGeneric: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    flexDirection: 'row',
    fontSize: '16px',
    fontWeight: 'bold',
    margin: '0px 5px',
    color: 'var(--color-text-sec)',
    borderRadius: 'var(--border-radius-low)',
  },
  buttonContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '5px',
  },
  buttomPix: {
    marginTop: '10px',
    fontSize: '16px',
    borderWidth: '1.5px',
    borderColor: '#00cda4',
    color: '#00cda4',
  },
}
